module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-info--layout"
  }, [_c('div', {
    staticClass: "drug-table"
  }, [_c('div', {
    staticClass: "drug-table--row drug-img--row"
  }, [_vm._m(0), _c('div', {
    staticClass: "drug-table--cell"
  }, [(_vm.selectedDrug.drug_picture_1 !== null) ? _c('img', {
    staticClass: "drug-table--cell-image",
    attrs: {
      "src": _vm.selectedDrug.drug_picture_1
    },
    on: {
      "click": _vm.showFocus
    }
  }) : _vm._e(), (_vm.selectedDrug.drug_picture_1 === null) ? _c('span', {
    staticStyle: {
      "margin": "0 60px"
    }
  }, [_vm._v("無照片")]) : _vm._e(), (_vm.selectedDrug.drug_picture_2 !== null) ? _c('img', {
    staticClass: "drug-table--cell-image",
    attrs: {
      "src": _vm.selectedDrug.drug_picture_2
    },
    on: {
      "click": _vm.showFocus
    }
  }) : _vm._e(), (_vm.selectedDrug.drug_picture_2 === null) ? _c('span', {
    staticStyle: {
      "margin": "0 60px"
    }
  }, [_vm._v("無照片")]) : _vm._e()])]), _c('div', {
    staticClass: "drug-table--row drug-desc--row"
  }, [_vm._m(1), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDrug.generic_name))])])]), _c('div', {
    staticClass: "drug-table--row drug-desc--row"
  }, [_vm._m(2), _c('div', {
    staticClass: "drug-table--cell"
  }, [(_vm.selectedDrug.product_name === null) ? _c('span', [_vm._v("未設定")]) : _c('span', [_vm._v(_vm._s(_vm.selectedDrug.product_name))])])]), _c('div', {
    staticClass: "drug-table--row drug-desc--row"
  }, [_vm._m(3), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDrug.code) + " / " + _vm._s(_vm.selectedDrug.CGMH_number))])])]), (_vm.currentDrugInDevice === null) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(4), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDrug.note))])])]) : _vm._e(), (_vm.currentDrugInDevice !== null) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(5), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', {
    class: {
      'color-red': _vm.remainExpiredDays < 30
    }
  }, [_vm._v(_vm._s(_vm.currentDrugInDevice.expired_date) + " "), (_vm.currentDrugInDeviceExpired) ? _c('span', [_vm._v("(已過期)")]) : _vm._e(), (_vm.remainExpiredDays < 30 && !_vm.currentDrugInDeviceExpired) ? _c('span', [_vm._v("(剩餘 " + _vm._s(_vm.remainExpiredDays) + " 天過期)")]) : _vm._e()])])]) : _vm._e(), (_vm.currentDrugInDevice !== null) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(6), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentDrugInDevice.patch_number))])])]) : _vm._e(), (_vm.currentDrugInDevice !== null && _vm.lastEvent) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(7), _c('div', {
    staticClass: "drug-table--cell"
  }, [(Object.values(_vm.lastEvent).length === 0) ? _c('span', [_vm._v("無")]) : _c('span', [_vm._v(_vm._s(_vm._f("readabletime")(_vm.lastEvent.record_time)) + " 由 " + _vm._s(_vm.lastEvent.employee_name) + " 進行 " + _vm._s(_vm.lastEvent.event_type.event_name_zh) + " "), (_vm.lastEvent.number1) ? _c('span', [_vm._v("(數量: " + _vm._s(_vm.lastEvent.number1) + ")")]) : _vm._e()])])]) : _vm._e()]), (_vm.focusModalStatus) ? _c('FocusModal', {
    attrs: {
      "message": _vm.foucsMessage
    },
    on: {
      "close": _vm.closeFocus
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("藥物圖片")]), _c('div', [_vm._v("(點擊放大)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("學名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("商品名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("藥碼 / 料位號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("注意事項")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("有效期限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("上次操作事件")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e5fe992","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/DrugInfo.vue
// module id = 1517
// module chunks = 1